<template>
  <!--<div class="caption-head" @click.stop="showHideSubMenu(1)">-->
    <!--<div class="caption-head-text">-->
      <!--<span>Language</span>-->
    <!--</div>-->
    <!--<div class="caption-head-icon">-->
      <!--<span class="active-chevron" v-if="filerTableHead.selectedCeil === 1">-->
        <!--<icon name="chevron-up"></icon>-->
      <!--</span>-->
      <!--<span class="passive-chevron" v-if="filerTableHead.selectedCeil !== 1">-->
        <!--<icon name="chevron-down"></icon>-->
      <!--</span>-->
    <!--</div>-->
  <!--</div>-->
  <!--<div class="wrap-dropdown-table-head"-->
       <!--id="sub-menu-1"-->
       <!--v-show="filerTableHead.selectedCeil === 1"-->
       <!--tabindex="-1"-->
       <!--@click.stop="">-->
    <!--<app-select placeholder="Search here ..."-->
                <!--:options="getLanguagesForSelect"-->
                <!--v-model="languages"-->
                <!--:multiple="true"-->
                <!--:class="'hide-selected-items'"/>-->
  <!--</div>-->
</template>

<script>
  import 'vue-awesome/icons/chevron-up'
  import 'vue-awesome/icons/chevron-down'
export default {
    name: 'languageArticle',
    data: function () {
      return {
        lngs: ['English (UK)', 'English (US)'],
        confirmation: {
          action: '',
          isShown: false,
          articleId: null,
          i: null
        }
      }
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// languageArticles.vue?648cad8d